import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PRODUCTCOMPLAIN,
  DELETE_PRODUCTCOMPLAIN,
  UPDATE_PRODUCTCOMPLAIN,
  ADD_NEW_PRODUCTCOMPLAIN,
} from "./actionType";

import {
  getProductComplainSuccess,
  getProductComplainFail,
  deleteProductComplainSuccess,
  deleteProductComplainFail,
  updateProductComplainSuccess,
  updateProductComplainFail,
  addProductComplainSuccess,
  addProductComplainFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveProductComplainApi,
  getProductComplainApi,
  updateProductComplainApi,
  deleteProductComplainApi,
  addNewProductComplainApi
} from "../../helpers/backend_helper";

function* getProductComplain({ payload: productComplain }) {
  try {
    const response = yield call(getProductComplainApi, productComplain);
    yield put(getProductComplainSuccess(GET_PRODUCTCOMPLAIN, response.data));
  } catch (error) {
    yield put(getProductComplainFail(GET_PRODUCTCOMPLAIN, error));
  }
}

function* onUpdateProductComplain({ payload: productComplain }) {
  try {
    if (productComplain.setApprove) {
      const response = yield call(approveProductComplainApi, productComplain);
      yield put(updateProductComplainSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateProductComplainApi, productComplain);
      yield put(updateProductComplainSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateProductComplainFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteProductComplain({ payload: productComplain }) {
  try {
    const response = yield call(deleteProductComplainApi, productComplain);
    yield put(deleteProductComplainSuccess({ productComplain, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteProductComplainFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewProductComplain({ payload: productComplain }) {
  try {
    const response = yield call(addNewProductComplainApi, productComplain);
    yield put(addProductComplainSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addProductComplainFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetProductComplain() {
  yield takeEvery(GET_PRODUCTCOMPLAIN, getProductComplain);
}

export function* watchUpdateProductComplain() {
  yield takeEvery(UPDATE_PRODUCTCOMPLAIN, onUpdateProductComplain);
}

export function* watchDeleteProductComplain() {
  yield takeEvery(DELETE_PRODUCTCOMPLAIN, onDeleteProductComplain);
}

export function* watchAddNewProductComplain() {
  yield takeEvery(ADD_NEW_PRODUCTCOMPLAIN, onAddNewProductComplain);
}

function* productComplainSaga() {
  yield all([
    fork(watchGetProductComplain),
    fork(watchDeleteProductComplain),
    fork(watchUpdateProductComplain),
    fork(watchAddNewProductComplain)
  ]);
}

export default productComplainSaga;
